import React from "react";
import { Stack, Typography } from "@mui/material";

import EmptyImage from "assets/bcba_dashboar_empty_section.png";

const EmptyDeliveredHours = () => {
  return (
    <Stack alignItems="center" textAlign="center" my={5} data-testid="empty-delivered-hours">
      <img src={EmptyImage} height={223} alt="Empty delivered hours" />
      <Typography variant="subtitle1">Stay in the loop as you deliver therapy hours.</Typography>
      <Typography variant="body2" color="text.secondary">
        As therapy hours are submitted and approved, they&apos;ll appear here.
      </Typography>
    </Stack>
  );
};

export default EmptyDeliveredHours;
